import Vue from 'vue';
import {Prop, Watch} from 'vue-property-decorator';
import Component, {mixins} from 'vue-class-component';
import {VuexObjectMixin} from '../../../Mixins';
import {SubmitOrderResponse} from '../../../Models';
import {LocalStorageUtility} from '../../../Utilities';

export interface TicketDownloadResponse {
  tickets: TicketDownloadInformation[];
  registrationCodes: string[];
}

interface TicketDownloadInformation {
  name: string | null;
  eventTitle: string | null;
  clientTitle: string | null;
  productTitle: string | null;
  pubTransIncluded: string | null;
  linkPdf: string | null;
  linkWallet: string | null;
  date: string | null;
}

@Component
export default class CheckoutSuccessView extends mixins(VuexObjectMixin) {
  @Prop({type: String, required: true}) inventoryUrl: string | undefined;
  @Prop({type: String, required: true}) loginUrl: string | undefined;
  @Prop({type: String, required: true}) loginPageUrl: string | undefined;
  @Prop({type: String, required: true}) ticketShopUrl: string | undefined;
  private downloadLinkProgress: number = 0;
  private submitOrderResponse: SubmitOrderResponse | null = null;
  private ticketDownloadResponse: TicketDownloadResponse | null = null;
  private loading: boolean = false;
  private error: boolean = false;

  async mounted() {
    this.submitOrderResponse = LocalStorageUtility.load<SubmitOrderResponse>('submittedOrder', new SubmitOrderResponse());
    if (this.submitOrderResponse?.provideDownloadLinkEventIds.length && this.submitOrderResponse.jwt !== null) {
      this.loading = true;
      await this.provideDownloadLinks();
    }
    LocalStorageUtility.delete('submittedOrder');
  }

  async getDownloadLinks(authJWT: string): Promise<TicketDownloadResponse | null> {
    if (this.submitOrderResponse) {
      try {
        return await this.orderService.getDownloadLinksWebshop(this.submitOrderResponse.orderId!.toString(), this.submitOrderResponse.userLanguage!, authJWT);
      } catch (e) {
        this.error = true;
        this.loading = false;
      }
    }
    return null;
  }

  async getDownloadLinksProgress(authJWT: string) {
    if (this.submitOrderResponse) {
      try {
        return await this.orderService.getDownloadLinksProgressWebshop(
          this.submitOrderResponse.orderId!.toString(),
          this.submitOrderResponse.userLanguage!,
          authJWT,
        );
      } catch (e) {
        // TODO: sentry error
        this.error = true;
        this.loading = false;
        return null;
      }
    }
  }

  private async provideDownloadLinks() {
    if (this.submitOrderResponse && this.submitOrderResponse.jwt) {
      let downloadLinksProgressResult = {
        status: 0,
        progress: 0,
      };
      downloadLinksProgressResult = await this.getDownloadLinksProgress(this.submitOrderResponse.jwt);
      this.downloadLinkProgress = downloadLinksProgressResult.progress;
      const getDownloadLinksIntervall = setInterval(
        async () => {
          if (this.submitOrderResponse && this.submitOrderResponse.jwt) {
            if (downloadLinksProgressResult.status === 200) {
              clearInterval(getDownloadLinksIntervall);
              if (this.downloadLinkProgress < 80) {
                this.downloadLinkProgress = 80;
              }
              const downloadLinksResult = await this.getDownloadLinks(this.submitOrderResponse.jwt);
              if (downloadLinksResult) {
                this.downloadLinkProgress = 100;
                this.ticketDownloadResponse = downloadLinksResult;
              }
              this.loading = false;
            } else {
              downloadLinksProgressResult = await this.getDownloadLinksProgress(this.submitOrderResponse.jwt);
              if (downloadLinksProgressResult !== null) {
                this.downloadLinkProgress = downloadLinksProgressResult.progress;
              } else {
                clearInterval(getDownloadLinksIntervall);
              }
            }
          }
        },
        5000,
      );
    }
  }
}
